<template>
  <Adminlte>
      <div class="box box-primary center-block">
        <div class="box-header with-border">
          <i class="fa fa-table font-dark"></i>
          <h3 class="box-title">Exportação de dados - Parques</h3>
        </div>

        <section class="content">
          <div class="row main-row">
            <div class="col-md-offset-2 col-md-8 col-lg-offset-3 col-lg-6">
              <div class="inner-box">
                <ParksFilter :parks="parks" :disabled="waitingDownload" />
              </div>

              <button
                class="btn btn-block btn-success"
                @click="handleDownloadClick"
                :disabled="waitingDownload || selectedParksIds.length === 0"
              >
                Baixar arquivo em formato Excel &nbsp;
                <i class="fa fa-refresh fa-spin" v-if="waitingDownload"></i>
              </button>
            </div>
          </div>
        </section>
      </div>
  </Adminlte>
</template>

<script>
  import Adminlte from '@/components/template/Adminlte'
  import ParksFilter from './ParksFilter'
  import { BackendApi } from '@/services/backend_api'
  import { saveAs } from 'file-saver'

  export default {
    name: 'ExportParks',
    components: { Adminlte, ParksFilter },
    data: function () {
      return {
        parks: [],
        waitingDownload: false
      }
    },
    async mounted () {
      this.parks = await this.getParks()
    },
    methods: {
      async getParks () {
        const response = await BackendApi.getAnonymousClient().get('/parks?hideLogo=true&orderBy=name&limit=0')
        const parksResponseWithNoLinksNeitherTotalElements = Object.values(response.data).slice(0, -2)
        return parksResponseWithNoLinksNeitherTotalElements.map((park) =>
          Object.assign({ isSelected: true }, park)
        )
      },
      handleDownloadClick (e) {
        e.preventDefault()

        const queryParams = {
          parks: this.selectedParksIds.join(',')
        }

        this.waitingDownload = true
        BackendApi.getClient().get('/spreadsheet/parks', {
          params: queryParams, responseType: 'blob'
        }).then((response) => {
          saveAs(response.data, 'parks.xlsx')
        }).finally(() => {
          this.waitingDownload = false
        })
      }
    },
    computed: {
      selectedParksIds: function () {
        return this.parks.filter((park) => park.isSelected).map((park) => park.id)
      }
    }
  }
</script>

<style scoped>
  .inner-box {
    background-color: #488ab3;
    box-shadow: 0px 1px 5px #888888;
    padding: 10px;
    margin-bottom: 15px;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// ExportParks.vue?8f5e6f08